export default "__VITE_ASSET__CUCs4W2G__"